<template>
  <div>
    <!-- 搜索区域 -->
    <global-tag>
      <span slot="title">人员类型</span>
      <div class="search" slot="search">
        <el-form :model="queryInfo" label-width="90px">
          <el-row type="flex" justify="start">
            <el-col :span="6">
              <el-form-item label="人员类型：">
                <el-input
                  clearable
                  placeholder="请输入"
                  v-model="queryInfo.serviceName"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态：">
                <el-select clearable v-model="queryInfo.state" placeholder="请选择">
                  <el-option label="启用" :value="1"></el-option>
                  <el-option label="禁用" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2" :offset="2" style="margin-left: 60%">
              <el-button size="mini" type="primary" @click="QuerySearch">查询</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </global-tag>
    <!-- 表格主体区域 -->
    <div>
      <!-- 新增按钮,下拉 -->
      <div class="btn_group">
        <div>
          <el-button-group>
            <el-button
              type="success"
              icon="iconfont icon-xinzeng"
              @click="showDialog('新增')"
              >新增</el-button
            >
          </el-button-group>
        </div>
        <el-button-group>
          <el-button type="primary" icon="el-icon-refresh" @click="Reset"></el-button>
          <!-- <el-button type="primary" style="padding: 10px 20px"> -->
          <el-dropdown class="dropdown1" trigger="click" :hide-on-click="false">
            <span class="el-dropdown-link">
              <i class="el-icon-s-grid el-icon--right" style="color: #fff"></i>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="table_checkbox">
              <el-dropdown-item>
                <el-checkbox-group v-model="tableChekbox" @change="tableChekboxChange">
                  <el-checkbox label="序号"></el-checkbox><br />
                  <el-checkbox label="人员类型"></el-checkbox><br />
                  <el-checkbox label="状态"></el-checkbox><br />
                  <el-checkbox label="操作"></el-checkbox><br />
                </el-checkbox-group>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- </el-button> -->
        </el-button-group>
      </div>
      <!-- 表格 -->
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :header-cell-style="{
            background: '#f2f2f2',
            color: '#000',
          }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="80"
            align="center"
            v-if="this.tempTableChekbox.findIndex((item) => item == '序号') != -1"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="serviceName"
            label="人员类型"
            align="center"
            v-if="this.tempTableChekbox.findIndex((item) => item == '服务类型') != -1"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="state"
            label="状态"
            align="center"
            v-if="this.tempTableChekbox.findIndex((item) => item == '状态') != -1"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.state"
                active-value="1"
                inactive-value="0"
                inactive-color="#ff4949"
                active-color="#13ce66"
                @change="changeStatic($event, scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="300"
            align="center"
            v-if="this.tempTableChekbox.findIndex((item) => item == '操作') != -1"
          >
            <template slot-scope="scope">
              <el-row type="flex" justify="start">
                <el-col :span="7">
                  <el-link :underline="false" @click="showDialog('查看', scope.row)"
                    >查看</el-link
                  >
                </el-col>
                <el-col :span="7">
                  <el-link :underline="false" @click="showDialog('编辑', scope.row)"
                    >编辑</el-link
                  >
                </el-col>
                <el-col :span="7">
                  <el-link :underline="false" @click="deleteItem(scope.row)"
                    >删除</el-link
                  >
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="bottom-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 40, 100]"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹框 -->
    <!-- 新增,查看,编辑弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="590px"
      @close="dialogVisibleClone"
    >
      <el-form
        ref="addformRef"
        :rules="formDateRules"
        :model="addForm"
        label-width="100px"
        :disabled="dialogTitle == '查看'"
      >
        <el-form-item label="人员类型:" prop="serviceName">
          <el-input
            v-model="addForm.serviceName"
            placeholder="请输入"
            style="width: 100%"
          ></el-input>
        </el-form-item>

        <el-form-item label="状态:" prop="state">
          <el-radio-group v-model="addForm.state">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer btnSite">
        <el-button size="small" type="primary" @click="send">确 定</el-button>
        <el-button size="small" @click="resetForm">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import globalTag from "../components/globalTag";
import request from "@/utils/request.js";
export default {
  name: "personnelType1",
  components: {
    globalTag,
  },
  data() {
    return {
      formDateRules: {
        serviceName: [{ required: true, message: "请输入姓名", trigger: "blur" }], // 服务类型
        state: [
          {
            required: true,
            message: "请选择是否启用",
            trigger: "blur",
          },
        ], // 状态
      },
      dialogTitle: "", // 新增,查看,编辑弹框标题
      dialogVisible: false, // 新增,查看,编辑弹框的显示与隐藏
      actionUrl: "", // 图片上传地址
      // 查询信息
      queryInfo: {},
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      tempTableChekbox: ["序号", "服务类型", "状态", "操作"],
      tableChekbox: ["序号", "服务类型", "状态", "操作"],
      // 表格信息
      tableData: [],
      // 新增表单数据
      addForm: {},
    };
  },
  created() {
    this.showList();
  },
  inject: ["reload"], //注入
  mounted() {},
  methods: {
    submit() {
      if (this.dialogTitle == "新增") {
        let params = {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          type: "11",
        };
        this.$http
          .request({
            url: "/jgyl/admin/serviceName/info/findList",
            method: "POST",
            data: params,
          })
          .then((res) => {
            if (res.code == 200) {
              if (res.content != null || res.content != "null") {
                for (let i = 0; i < res.content.list.length; i++) {
                  if (this.addForm.typeName == res.content.list[i].typeName) {
                    this.$message.error("该类型已存在");
                    return false;
                  }
                }
                this.$http
                  .request({
                    url: "/jgyl/admin/serviceName/info/insert",
                    method: "POST",
                    data: {
                      ...this.addForm,
                    },
                  })
                  .then((res) => {
                    if (res.code == 200) {
                      this.showList();
                      this.reload();
                    }
                  });
                this.dialogVisible = false;
              }
            }
          });
      } else if (this.dialogTitle == "编辑") {
        this.$http
          .request({
            url: "/jgyl/admin/serviceName/info/update",
            method: "POST",
            data: {
              ...this.addForm,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.showList();
              this.reload();
            }
          });
        this.dialogVisible = false;
      } else {
        this.dialogVisible = false;
      }
    },
    resetForm() {
      this.dialogVisible = false;
      // this.$refs.addformRef.resetFields();
    },
    dialogVisibleClone() {
      this.dialogVisible = false;
      this.$refs.addformRef.resetFields();
    },
    send() {
      this.$refs["addformRef"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$message.error("请按照提示正确输入");
          return false;
        }
      });
    },
    showList() {
      let params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        type: "11",
      };
      this.$http
        .request({
          url: "/jgyl/admin/serviceName/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = [];
              this.total = 0;
              return;
            }
            this.tableData = [];
             this.tableData = res.content.list
            // this.total = res.content.count
          }
        });
    },
    // 页面刷新
    Reset() {
      this.reload();
    },
    //table列checkbox发生变化
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item);
    },
    // 查询信息
    QuerySearch() {
      let params = {
        pageNo: 1,
        pageSize: 10,
        type: "11",
        serviceName: this.queryInfo.serviceName,
        state: this.queryInfo.state,
      };
      this.$http
        .request({
          url: "/jgyl/admin/serviceName/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = [];
              this.total = 0;
              return;
            }
            this.tableData = [];
             this.tableData = res.content.list
             this.total = res.content.count
          }
        });
    },
    // 打开新增弹框
    showDialog(title, row) {
      this.dialogTitle = title;
      this.dialogVisible = true;
      switch (title) {
        case "新增":
          this.addForm = {
            type: "11",
            state: "",
          };
          break;
        case "查看":
          break;
        case "编辑":
          break;
      }
      if (title != "新增") {
        this.$http
          .request({
            url: "/jgyl/admin/serviceName/info/get",
            method: "POST",
            data: {
              id: row.id,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.addForm = res.content;
              return;
            }
            this.$message({
              message: "根据ID获取信息失败",
              type: "error",
            });
          });
      }
    },
    // 分页
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.showList();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.query.pageNo = val;
      this.showList();
      console.log(`当前页: ${val}`);
    },
    changeStatic(e, data) {
      let state = "";
      if (e == 0) {
        state = 0;
      } else {
        state = 1;
      }
      request({
        url: "/jgyl/admin/serviceName/info/update",
        method: "POST",
        data: {
          id: data.id,
          state: state,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.showList();
        }
      });
    },
    // 删除
    async deleteItem(row) {
      const confirm = await this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      console.log(confirm);
      if (confirm === "confirm") {
        request({
          url: "/jgyl/admin/serviceName/info/delete",
          method: "POST",
          data: {
            id: row.id,
          },
        }).then((res) => {
          if (res.code == 200) {
            this.showList();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            return;
          }
          this.$message({
            message: "删除失败",
            type: "error",
          });
        });
      } else {
        this.$message({
          message: "取消删除",
          type: "info",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc;
}
.btn_group {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btnSite {
  display: flex;
  justify-content: center;
}
</style>
